// removed by extract-text-webpack-plugin
module.exports = {"pause":"_37mu","c":"_1vhq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pause/index.less
// module id = 261
// module chunks = 0